import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../../../ThemeContext';
import relayStreamLogo from '../../../relaystream-logo.png';
import './SidebarMenu.css';

export default function SidebarMenu() {
  const [collapsed, setCollapsed] = useState(false);
  const { toggleTheme } = useTheme();
  const logoIcon = localStorage.getItem('username')
    ? localStorage.getItem('username').charAt(0).toUpperCase()
    : 'R';

  return (
    <nav className={`rs-sidebar${collapsed ? ' collapsed' : ''}`}>
      {/* Logo */}
      <div className="rs-sidebar-logo">
        {collapsed
          ? <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--green)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 18, color: '#fff' }}>{logoIcon}</div>
          : <img src={relayStreamLogo} alt="Relay Stream" />
        }
      </div>

      {/* Collapse toggle — hidden on mobile horizontal nav via CSS */}
      <button className="rs-nav-item rs-sidebar-toggle" onClick={() => setCollapsed(c => !c)} title="Toggle menu">
        <span className="rs-nav-icon">{collapsed ? '→' : '←'}</span>
        <span className="rs-nav-label">Recolher</span>
      </button>

      {/* Dashboard */}
      <NavLink exact to="/dashboard/main" activeClassName="active" className="rs-nav-item" title="Dashboard">
        <span className="rs-nav-icon">📺</span>
        <span className="rs-nav-label">Dashboard</span>
      </NavLink>

      {/* Social Media destinations */}
      <NavLink to="/dashboard/social/platform" activeClassName="active" className="rs-nav-item" title="Redes Sociais">
        <span className="rs-nav-icon">📡</span>
        <span className="rs-nav-label">Redes Sociais</span>
      </NavLink>

      {/* Analytics */}
      <NavLink to="/dashboard/social/statistics" activeClassName="active" className="rs-nav-item" title="Análise">
        <span className="rs-nav-icon">📊</span>
        <span className="rs-nav-label">Análise</span>
      </NavLink>

      {/* Account */}
      <NavLink to="/dashboard/account" activeClassName="active" className="rs-nav-item" title="Minha Conta">
        <span className="rs-nav-icon">⚙️</span>
        <span className="rs-nav-label">Minha Conta</span>
      </NavLink>

      {/* Theme toggle */}
      <button className="rs-nav-item" onClick={toggleTheme} title="Tema">
        <span className="rs-nav-icon">🌙</span>
        <span className="rs-nav-label">Tema</span>
      </button>
    </nav>
  );
}



// WEBPACK FOOTER //
// ./src/components/DashboardPage/SidebarMenu/SidebarMenu.js